/**
 * Portal brand colours the evergreen components take as prop values.
 *
 * Evergreen reads a colour off a Box prop (`<Heading color={...}>`, `<Icon color={...}>`), not off a
 * class, so these live here rather than in the Tailwind palette. A `className` consumer keeps using
 * the Tailwind token.
 */

/** Page and section headings, and the border on the email hover card. */
export const PORTAL_NAVY = '#063370';
